export default [
  {
    name: 'Busca - Clientes',
    tabName: 'Clientes',
    icon: 'head-money',
    path: 'companies',
    component: 'SearchClient'
  },
  {
    name: 'Busca - Ofertas',
    tabName: 'Ofertas',
    icon: 'percent',
    path: 'campaigns',
    component: 'SearchCampaign'
  },
  {
    name: 'Busca - Parceiros',
    tabName: 'Parceiros',
    icon: 'percent',
    path: 'partners',
    component: 'SearchPartner'
  }
]



// WEBPACK FOOTER //
// ./src/content/searchComponents.js